<ngx-panel class="ai-marker-set-panel">
	<panel-heading>
		<div class="title ellipsis">
			@if (!title) {
				<span class="set-markers-header" translate="chart_title-ai_prompt"></span>
			} @else {
				<span class="set-defaults-header" translate="default-ai-marker-title"></span>
			}
		</div>

		<ngx-toolbar>
			@if (canPreview) {
				<ngx-toolbar-button
					class="preview-btn"
					[action]="toolbarActions.PREVIEW"
					(clicked)="onPreview.emit()">
				</ngx-toolbar-button>
			}
			<ngx-toolbar-button
				class="edit-btn"
				[action]="toolbarActions.EDIT"
				(clicked)="onEdit.emit()">
			</ngx-toolbar-button>
			<ngx-toolbar-button
				class="remove-btn"
				[action]="toolbarActions.REMOVE"
				(clicked)="onRemove.emit()">
			</ngx-toolbar-button>
		</ngx-toolbar>
	</panel-heading>

	<panel-body>
		@if (title) {
			<span>{{ title }}</span>
		}
		<marker-display
			[aiStyle]="true"
			[markers]="markers">
		</marker-display>
	</panel-body>
</ngx-panel>
